import { GET_USER } from './actionTypes'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_USER:
      return action.payload
    default:
      return state
  }
}

// 1: it is a function without name
// 2: it is export default
// 3: the case has a default:
// 4: the check is against action.type



// WEBPACK FOOTER //
// ./src/redux/userReducer.js